<div class="py-4 flex space-x-4 text-16">
  <div class="w-[24px] shrink-0"></div>
  <div class="space-y-4">
    <div>{{ row.title }}</div>
    <div *ngIf="row.text" class="text-12 italic font-extralight">
      {{ row.text }}
    </div>
  </div>
</div>
<div
  class="bg-theme-white grid gap-8 py-4"
  [ngClass]="{
    'grid-cols-3': languageService.isEliteEnabled,
    'grid-cols-2': !languageService.isEliteEnabled
  }"
>
  <div class="flex items-center justify-center">
    <svg-icon
      src="assets/images/svg-icons/{{ row.availableInFree ? 'icon-yes-green' : 'icon-no-red' }}.svg"
      [svgStyle]="{ 'width.px': '24' }"
    ></svg-icon>
  </div>
  <div class="flex items-center justify-center">
    <svg-icon
      src="assets/images/svg-icons/{{
        row.availableInPremiumPlus ? 'icon-yes-green' : 'icon-no-red'
      }}.svg"
      [svgStyle]="{ 'width.px': '24' }"
    ></svg-icon>
  </div>
  <div *ngIf="languageService.isEliteEnabled" class="flex items-center justify-center">
    <svg-icon
      src="assets/images/svg-icons/{{
        row.availableInElite ? 'icon-yes-green' : 'icon-no-red'
      }}.svg"
      [svgStyle]="{ 'width.px': '24' }"
    ></svg-icon>
  </div>
</div>
